import { DependencyList, useCallback, useEffect, useRef } from 'react'

// Browser side usage only
export function useDebouncedCallback<A extends any[]>(
  callback: (...args: A) => void,
  deps: DependencyList = [],
  wait = 500
) {
  const callbackRef = useRef<(...args: A) => void>(callback)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined
  )

  const debouncedCallback = useCallback(
    (...args: A) => {
      clearTimeout(timeoutRef.current)

      timeoutRef.current = setTimeout(() => {
        callbackRef.current(...args)
      }, wait)
    },
    [wait]
  )

  useEffect(() => {
    callbackRef.current = callback
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  useEffect(() => () => clearTimeout(timeoutRef.current), [])

  return debouncedCallback
}
